import React, { useState, useContext, useEffect } from 'react'
import { useTranslation } from 'react-i18next'

import { API__ANALYTICS } from 'api'

import DataGrid from 'components/Form/DataGrid/DataGrid'
import Loader from 'components/Loader/Loader'
import Placeholder from 'components/Form/Placeholder/Placeholder'

import { downloadCSV } from 'common/utils/files'

import AnalyticsContext from '../../analyticsContext'

import { getColumns } from './utils'

import Header from './components/Header/Header'
import Details from './components/Details/Details'

import styles from './Rewards.module.scss'

const Rewards = () => {
    const { t } = useTranslation()

    const [isShowInactive, setIsShowInactive] = useState(false)
    const [isShowEmpty, setIsShowEmpty] = useState(false)
    const [rewards, setRewards] = useState(null)
    const [selectedReward, setSelectedReward] = useState(null)
    const [isLoading, setIsLoading] = useState(false)

    const {
        projectProjection: { projectId, rewards: rewardsProjection },
    } = useContext(AnalyticsContext)

    useEffect(() => {
        if (!rewardsProjection) {
            setIsShowInactive(true)
            return
        }
        fetchData()
    }, [])

    const fetchData = async () => {
        try {
            setIsLoading(true)
            const data = await API__ANALYTICS.GET_PROJECT_PRIZE_DRAW_STATISTICS({
                projectId,
                drawId: rewardsProjection.prizeDrawExternalKey,
            })
            setRewards(data)
        } catch (err) {
            console.error(err)
            if (err?.response?.status === 404) {
                setIsShowEmpty(true)
            }
        } finally {
            setIsLoading(false)
        }
    }

    const saveCSV = async () => {
        const content = await API__ANALYTICS.GET_PRIZE_DRAW_CSV(projectId, rewardsProjection.prizeDrawExternalKey)
        downloadCSV(content, 'rewards.csv')
    }

    return (
        <>
            <h1>{t('Rewards')}</h1>
            {!!rewards && (
                <div className={styles.data}>
                    <Header rewards={rewards} onSaveCSV={saveCSV} />
                    <DataGrid
                        emptyText={t('Rewards data will appear there')}
                        columns={getColumns(rewards.prizeItemDtos, reward => setSelectedReward(reward))}
                        pagination={{ content: rewards.prizeItemDtos }}
                        isHidePagination
                    />
                </div>
            )}
            {isLoading && !rewards && <Loader className={styles.loader} />}
            {isShowEmpty && <Placeholder title={t('Rewards data will appear here')} />}
            {isShowInactive && (
                <DataGrid
                    emptyText={t('Activate the use of rewards in the editor and the data will be appear here')}
                    columns={getColumns([], reward => setSelectedReward(reward))}
                    pagination={{ content: [] }}
                    isHidePagination
                />
            )}
            {!!selectedReward && <Details reward={selectedReward} onClose={() => setSelectedReward(null)} />}
        </>
    )
}

export default Rewards
